'use client';

import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { useBoundaryErrorReport } from '@/lib/observability/report-boundary-error';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useBoundaryErrorReport('root', error);
  const tc = useTranslations('common');
  return (
    <div style={{ padding: 'var(--s-8)', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'var(--s-4)' }}>
      <h1>{tc('error')}</h1>
      <p>{error.message}</p>
      <Button onClick={() => reset()}>{tc('retry')}</Button>
    </div>
  );
}
